import SignUpForm from '../../components/form/forms/sign-up.form';
import AuthLayout from '../../components/layouts/auth.layout';

export default function Login() {
  return (
    <AuthLayout title="sign up">
      <AuthLayout.Form>
        <SignUpForm />
      </AuthLayout.Form>
    </AuthLayout>
  );
}
